/* eslint-disable no-useless-computed-key */
import React, { useEffect, useMemo, useState } from "react";
import { fetchController } from "../../utils/FetchController/fetchController";
import Table from "../Tables/Table";
import { Box } from "@chakra-ui/react";
import { getHostDomain } from "../../utils/utils";
import NameWithDescriptionCell from "../shared/NameWithDescriptionCell";

const Sources = ({ assistantData }) => {
  const baseUrl = getHostDomain();
  const [rawSources, setRawSources] = useState([]);

  useEffect(() => {
    const fetchSources = async () => {
      if (!assistantData?.data?.id) return;

      try {
        const endpoint = `/api/v1/assistant/${assistantData.data.id}/list_data_sources`;
        const url = `${baseUrl}${endpoint}`;
        const response = await fetchController(url, "GET");

        if (response?.data) {
          setRawSources(response.data.items || []);
        }
      } catch (error) {
        console.error("Error fetching data sources:", error);
      }
    };

    fetchSources();
  }, [assistantData, baseUrl]);

  const tableData = useMemo(
    () =>
      rawSources.map((item) => ({
        ...item,
        name: (
          <NameWithDescriptionCell
            name={item.name}
            description={item.description}
            id={item.id}
          />
        ),
      })),
    [rawSources]
  );

  const columns = useMemo(
    () => [{ Header: "Name", accessor: "name" }],
    []
  );

  return (
    <Box width="50%">
      <Table columns={columns} data={tableData} />
    </Box>
  );
};

export default Sources;
